export default function VideoSection() {
  return (
    <section id="video" className="relative w-full bg-foreground-950 py-28 md:py-40">
      <div className="w-full px-6 md:px-16">
        {/* Section Label */}
        <div className="text-center mb-10 md:mb-14">
          <p className="font-sans text-[12px] tracking-[0.2em] text-foreground-400 mb-4">
            MOVIE / CM
          </p>
          <h2
            className="font-heading text-[22px] md:text-[30px] tracking-[0.1em] text-background-50"
            style={{ fontWeight: 300 }}
          >
            GIAZOブランドムービー
          </h2>
        </div>

        {/* YouTube Embed */}
        <div className="max-w-4xl mx-auto">
          <div
            className="relative w-full rounded-lg overflow-hidden"
            style={{ aspectRatio: '16/9' }}
          >
            <iframe
              className="absolute inset-0 w-full h-full"
              src="https://www.youtube.com/embed/LvMjjwfSuw0"
              title="GIAZO ブランドムービー"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}